<template>
  <div id="pagos-header">
    <div id="sig-container" class="full form-horizontal">
      <div class="widget">
        <div class="widget-content widget-content-mini themed-background-info text-light-op">
          <span class="float-right text-muted">
            <i class="fa fa-check"></i>
          </span>Importar información de contacto
        </div>
        <div class="widget-content border-bottom themed-background-muted text-center">
          <span
            class="muted-color"
          >Por medio de este modulo se podra cargar las gestiones realizadas.</span>
          <hr />
          <div class="row">
            <div class="loader" v-if="loading">
              <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
            </div>
            <div class="col-md-3"></div>
            <div align="center" class="col-md-6">
              <div class="row centrar">
                <label class="btn btn-primary">
                  <i class="fa fa-file-excel-o"></i>
                  <input
                    v-on:change="cargarGestion()"
                    id="archivo"
                    ref="archivo"
                    name="archivo"
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                    style="display: none;"
                  />
                  Seleccionar archivo
                </label>
                &nbsp;
                <a :href="'../files/formato-cargue-gestion.csv'" download>
                  <label class="btn btn-success">
                    <i class="fa fa-file-excel-o"></i>
                    Descargar archivo
                  </label>
                </a>
              </div>
              <div class="row centrar">
                <p>Si tienes el formato listo para el cargue de gestiones, podrás montarlo por medio del boton "Seleccionar archivo". En caso, contrario podras descargar el formato base para montar este cargue por medio de "Descargar archivo".</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapGetters({ loading: "cargueGestion/loading" })
  },
  methods: {
    cargarGestion() {
      this.file = this.$refs.archivo.files[0];
      let formData = new FormData();
      formData.append("datos", this.file);

      this.$store.commit("cargueGestion/setLoading", true);
      this.$store
        .dispatch("cargueGestion/cargarGestion", formData)
        .then(response => {
          this.$store.commit("cargueGestion/setLoading", false);
          this.$notify({
            title: "Archivo procesado",
            content: "Se ha importado con exito el archivo de gestiones.",
            type: "success"
          });

          if (response.data.length > 0) {
            let data = XLSX.utils.json_to_sheet(response.data);

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, "Gestiones - Log");
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "Log_Gestiones.xlsx"
            );
          } else {
            this.$notify({
              title: "Error!",
              content: "Se ha generado un error exportando el log.",
              type: "warning"
            });
          }
        })
        .catch(() => {
          this.$store.commit("cargueGestion/setLoading", false);
          this.$notify({
            title: "Fallo al importar",
            content:
              "Se produjo un error al tratar de importar el archivo, por favor inténtelo mas tarde." +
              error,
            type: "danger"
          });
        });
    }
  },
  mounted() {}
};
</script>
<style>
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.muted-color {
  color: #b9b9b9;
  font-style: italic;
}

.centrar {
  display: block;
}
</style>
